import MarketsTable from './MarketsTable';
import connect from './connect'

export default connect(MarketsTable);



// WEBPACK FOOTER //
// ./src/components/MarketsTable/index.js